/**
 * Check if the given value is an Error object
 */
export const isError = (error: unknown): error is Error =>
  error instanceof Error;
